module.exports = __webpack_public_path__ + "vue/img/report-avatar.4035bdff.png";